<div vmRemoveFromView="true">
  <nav aria-label="breadcrumb p-0" class="col-10 col-sm-12 breadcrumb">
    <div
      class="breadcrumb__container"
      [ngClass]="{
        'breadcrumb__light-text': !lightThemeSelected,
        'breadcrumb__dark-text': lightThemeSelected
      }"
    >
      <a
        href="{{ homePage }}"
        class="breadcrumb__container__link"
        [ngClass]="{
          'breadcrumb__light-text': !lightThemeSelected,
          'breadcrumb__dark-text': lightThemeSelected
        }" title="Home"
      >
        <i class="fas fa-home breadcrumb__container__icon"></i>
      </a>

      <div *ngIf="displayedCrumbs" class="breadcrumb__container">
        <ng-container *ngFor="let crumb of displayedCrumbs">
          <i
            class="fas fa-angle-left breadcrumb__container__icon__angle Body-X-Small"
            [ngClass]="'current-page-mobile'"
          ></i>

          <a
            *ngIf="crumb.routerLink !== null"
            routerLinkActive="active"
            [href]="crumb.routerLink"
            class="uk-link-reset breadcrumb__container__link"
            [ngClass]="{
              'breadcrumb__light-text': !lightThemeSelected,
              'breadcrumb__dark-text': lightThemeSelected
            }"
          >
            <span class="Body-Small-Book">{{ crumb.name }}</span>
          </a>
          <span *ngIf="crumb.routerLink === null" class="Body-Small-Book current-page-mobile">{{ crumb.name }}</span>
        </ng-container>
      </div>
    </div>
  </nav>
</div>
